import * as React from 'react';

import {ReelGridContainerConfigurationContext, frameworkReelGridContainer} from './reelgridcontainerconfiguration';

const withReelGridContainerConfiguration = <P extends object>(
    WrappedComponent: React.ComponentType<P>): React.FC<P> => {
    const HOC = (props: any): React.ReactElement => (
        <ReelGridContainerConfigurationContext.Consumer>
            {(auth: any): React.ReactElement => {
                return (
                    <WrappedComponent {...props}{...frameworkReelGridContainer}/>
                );
            }}
        </ReelGridContainerConfigurationContext.Consumer>
    );

    HOC.displayName = `withAuthentication(${WrappedComponent.displayName || WrappedComponent.name})`;
    HOC.WrappedComponent = WrappedComponent;
    return HOC;
};

export default withReelGridContainerConfiguration;